module.exports = __webpack_public_path__ + "static/img/data_jinse.d526f7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/data_jinse.png
// module id = VRld
// module chunks = 2